import { IconX } from "@tabler/icons-react";
import React from "react";
import Section from "../../../components/common/Section";

type Props = {
  open: boolean;
  onClose: () => void;
};

const InfoRow = ({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) => (
  <div className={`flex items-center gap-2 w-full ${className}`}>
    <div className=" ">
      <h2 className="capitalize text-[#212121] text-sm font-medium">
        {label} :
      </h2>
    </div>
    <div className=" ">
      <p className="text-[#1E293B] text-base">{value}</p>
    </div>
  </div>
);

const PickupViewModal = ({ open, onClose }: Props) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-screen  bg-black/60 z-50 flex items-center justify-end p-4">
        <div className="rounded-2xl w-5/12 relative">
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h1 className="text-2xl">View Pick Request</h1>
            </div>
            <div className="relative ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#F7F6F2"
                />
              </svg>

              <button
                onClick={onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div>
          <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]  ">
            <div className=" h-[calc(100vh-13rem)] overflow-y-auto space-y-4">
              <Section
                className="col-span-3"
                mainClassName="grid grid-cols-3 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="Sender Information"
              >
                <InfoRow label="Name" value="Ramesh Gupta" />
                <InfoRow label="Phone" value="987412020" />
                <InfoRow label="Email" value="ramesh@email.com" />
              </Section>

              <Section
                className="col-span-2"
                mainClassName="grid grid-cols-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="Pickup Address"
              >
                <InfoRow
                  label="Address"
                  value="A-12, Green Park, Delhi – 110016"
                />
                <InfoRow label="Hub" value="Delhi North Hub" />
              </Section>
              <Section
                className="col-span-2"
                mainClassName="grid grid-cols-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="Shipment Details"
              >
                <InfoRow
                  className="col-span-2"
                  label="No. of Packages"
                  value="5"
                />
                <InfoRow
                  label="Special Handling"
                  value="Fragile – handle with care"
                />
                <InfoRow label="Notes" value="Contains glass items" />
              </Section>
              <Section
                className="col-span-2"
                mainClassName="grid grid-cols-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="Preferred Pickup Time"
              >
                <InfoRow label="Date" value="28 Jun 2025" />
                <InfoRow label="Time Slot" value="2:00 PM – 4:00 PM" />
              </Section>

              <Section
                className="col-span-2"
                mainClassName="grid grid-cols-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="Driver Details"
              >
                <InfoRow label="Driver Code" value="Raj4564" />
                <InfoRow
                  label="Assigned Driver"
                  value="Rajesh Kumar (DL01AB1234)"
                />
                <InfoRow label="Vehicle" value="Mini Truck" />
                <InfoRow label="Contact" value="+91 99887 77665" />
                <InfoRow label="Proof of Pickup" value="📸 View Image" />
                <InfoRow label="Digital Signature" value="📝 View" />
              </Section>
              <Section
                className="col-span-2"
                mainClassName="grid grid-cols-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                title="RIW-Details"
              >
                <InfoRow label="Warehouse Name" value="Riyad Warehouse" />
                <InfoRow label="Received By" value="Rajesh Kumar" />
                <Section
                  className="col-span-2"
                  mainClassName="grid grid-cols-2 col-span-2 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
                  title="Shipment Received Details"
                >
                  <InfoRow label="Numbers of Shipments" value="100" />
                  <InfoRow label="Received" value="80" />
                  <InfoRow label="Missing" value="10" />
                  <InfoRow label="Damage" value="10" />
                </Section>
              </Section>
            </div>
          </div>
          <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
            <button
              className="bg-[#FBD037]  rounded-full px-6 py-2 text-[#212121] text-base font-medium"
              onClick={onClose}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PickupViewModal;
